import { FC, useState } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useMutation } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { InvitationFormProps, InvitationFormInput } from './types';
import { useStyles } from './styles';
import { useForm, Controller } from 'react-hook-form';
import CloseIcon from '@material-ui/icons/Close';
import { TextField, Button, Grid, Modal, Paper, IconButton, Input } from '@material-ui/core';
import { uid } from 'utils';

export const InvitationForm: FC<InvitationFormProps> = ({ open, refetch, handleClose }) => {
  const classes = useStyles();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isFilePicked, setIsFilePicked] = useState(false);
  const {
    invitationStore: { sendInvitation },
    notificationStore: { openNotification },
  } = useStore();

  const sendInvitationReq = useMutation((data: unknown) => sendInvitation(data), {
    mutationKey: 'sendInvitationReq',
    onSuccess: (e) => {
      openNotification('success', `${e}`);
      refetch();
      reset();
      setSelectedFile(null);
      setIsFilePicked(false);
      handleClose();
    },
    onError: (e) => openNotification('error', `${e}`),
  });

  useAppPreloader(sendInvitationReq.isLoading);

  const { control, handleSubmit, reset } = useForm<InvitationFormInput>();

  const onSubmit = (data: InvitationFormInput) => {
    data.users_file = selectedFile;
    return sendInvitationReq.mutate(data);
  };
  return (
    <Modal className={classes.modal} disablePortal disableEnforceFocus disableAutoFocus open={open}>
      <Paper className={classes.paper} elevation={3}>
        <Grid container justify='space-between' alignItems='center'>
          <p className={classes.label}>
            Enter list of emails or upload a .csv file to invite for people for registartion
          </p>
          <IconButton
            style={{ marginRight: -16 }}
            onClick={() => {
              reset();
              handleClose();
              setSelectedFile(null);
              setIsFilePicked(false);
            }}>
            <CloseIcon color='primary' />
          </IconButton>
        </Grid>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid className={classes.row} container justify='space-between'>
            <Grid className={classes.row} key={uid()} container justify='space-between'>
              <p className={classes.title}>List of Emails</p>
              <Controller
                name='emails'
                render={({ field, fieldState: { invalid } }) => (
                  <TextField
                    {...field}
                    className={classes.textField}
                    rows={4}
                    placeholder='Enter list of emails seperated by commas. like abc@xyz.com, xyz@abc.com'
                    error={invalid}
                    autoComplete='fname'
                    helperText={invalid ? 'Required field' : ''}
                    autoFocus={true}
                  />
                )}
                control={control}
              />
            </Grid>
            <Grid className={classes.row} key={uid()} container justify='space-between'>
              <p className={classes.title}>Upload .csv file</p>
              <div style={{ width: '100%' }}>
                <label htmlFor='file' className={classes.textFileField}>
                  Choose a file
                </label>
              </div>
              <Controller
                name='users_file'
                render={({ field, fieldState: { invalid } }) => (
                  <Input
                    {...field}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setSelectedFile(e.target.files ? e.target.files[0] : null);
                      setIsFilePicked(true);
                    }}
                    className={classes.textField}
                    rows={4}
                    type='file'
                    error={invalid}
                    style={{ display: 'none' }}
                    id='file'
                  />
                )}
                control={control}
              />
              {isFilePicked ? (
                <div>
                  <p>
                    Filename: {selectedFile?.name}
                    <span
                      onClick={() => {
                        setSelectedFile(null);
                        setIsFilePicked(false);
                      }}
                      className={classes.space}>
                      cancel
                    </span>
                  </p>
                  <p>Size in bytes: {selectedFile?.size}</p>
                </div>
              ) : (
                <p>Select a file to see details</p>
              )}
            </Grid>
          </Grid>
          <Button className={classes.btn1} type='submit' fullWidth variant='contained' color='primary'>
            Send Invitations
          </Button>
        </form>
      </Paper>
    </Modal>
  );
};
